Object.assign(window.intlTelInput.defaults, {
	autoPlaceholder: "off",
	countryOrder: ["US"],
	utilsScript: utilsScript
});

document.querySelectorAll(".phone-number").forEach(function (element) {

	var areaCodeElement, mainElement;

	if (element.tagName.toLowerCase() != "input")
	{
		var parts = element.querySelectorAll("input");
		areaCodeElement = parts[0];
		mainElement = parts[1];
	}
	else
		mainElement = element;

	var itiElement = document.createElement("input");
	itiElement.type = "text";
	itiElement.classList.add("form-control");
	itiElement.dataset.rulePhonenumber = "true";
	itiElement.setAttribute("name", "iti-" + mainElement.getAttribute("name"));
	itiElement.setAttribute("aria-label", "Phone number");
	itiElement.setAttribute("autocomplete", "tel");
	if (mainElement.required) itiElement.setAttribute("required", "");

	element.parentElement.appendChild(itiElement);

	var iti = window.intlTelInput(itiElement);

	itiElement.parentElement.style.display = "none";

	iti.promise.then(function () {	// Don't bother using element unless utils.js is fully loaded

		var number;

		if (areaCodeElement)
			number = (areaCodeElement.value == "011" ? '' : areaCodeElement.value) + mainElement.value;
		else
			number = element.value;

		if (number.startsWith("+"))
			iti.setNumber(number);
		else
		{
			iti.setNumber("+1" + number);	// Most likely a US number

			if (!iti.isValidNumberPrecise())
			{
				iti.setNumber("+" + number);

				if (!iti.isValidNumberPrecise())
					iti.setNumber(number);
			}
		}

		element.style.display = "none";
		itiElement.parentElement.style.display = "block";

		function setElements() {

			var number = iti.getNumber();
			var extension = iti.getExtension();

			if (areaCodeElement)
			{
				if (iti.getSelectedCountryData()['dialCode'] == "1")
				{
					areaCodeElement.value = number.substring(2, 5);
					mainElement.value = number.substring(5);
				}
				else
				{
					areaCodeElement.value = "011";
					mainElement.value = number;
				}
			}
			else
			{
				if (iti.getSelectedCountryData()['dialCode'] == "1")
					mainElement.value = number.substring(2);
				else
					mainElement.value = number;
			}

			if (extension)
				mainElement.value += " ext. " + extension;
		}

		setElements();

		itiElement.addEventListener("change", setElements);
	});
});
